import { parseChordPro } from '../chordpro/parse'
import { serializeChordPro } from '../chordpro/serialize'
import type { RevisionContent } from '../schema/v1'
import { validateContent, type Issue } from '../validate'
import { reconcileIds } from './reconcile'

/**
 * El cuerpo de una ficha como texto editable: secciones, letra, acordes y repeticiones en
 * ChordPro, sin el tono, la cejilla ni el tempo, que se editan en el formulario. Es lo que ve y
 * cambia el editor.
 */
export function bodyText(content: RevisionContent): string {
  return serializeChordPro({ content, header: false }).text
}

export interface AppliedBody {
  content: RevisionContent
  /** Avisos de lectura y reglas musicales sobre el resultado. */
  issues: Issue[]
}

/**
 * Aplica el texto editado a la revisión anterior: la estructura sale del texto y los IDs se
 * conservan allí donde nada cambió (reconcileIds). Todo lo que no es cuerpo (tono, cejilla,
 * procedencia, notas…) se queda como estaba.
 */
export function applyBody(previous: RevisionContent, text: string): AppliedBody {
  const parsed = parseChordPro(text, { bodyOnly: true, notation: 'auto' })
  const reconciled = reconcileIds(previous, parsed.content)
  const hasChords = reconciled.sections.some((section) =>
    section.lines.some((line) => line.chords.length > 0),
  )
  const content: RevisionContent = {
    ...previous,
    notation: hasChords ? parsed.content.notation : previous.notation,
    sections: reconciled.sections,
    sequence: reconciled.sequence,
    beatMap: reconciled.beatMap,
  }
  return { content, issues: [...parsed.issues, ...validateContent(content)] }
}
